import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core"
import { restrictToParentElement, restrictToVerticalAxis } from "@dnd-kit/modifiers"
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable"
import classNames from "classnames"
import React from "react"

import { Card } from "@/component/DraggableList/Card"

type DragProps = {
  cards: any[],
  setCards: (items: any[]) => void,
  className?: string
  cardClassName?: string
  showHandle?: boolean
  disabled?: boolean
}

function DraggableList(props: DragProps) {
  const { cards, setCards, cardClassName, showHandle = true, disabled = false } = props
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[
        restrictToVerticalAxis, // 限制仅垂直拖动
        restrictToParentElement, // 限制移动到父元素
      ]}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={cards.map((c) => c.id)}
        strategy={verticalListSortingStrategy}
        disabled={{
          draggable: false,
        }}
      >
        <div className={classNames(props.className, "draggable-wrapper")}>
          {cards.map((card) => <Card
            key={card.id}
            outClassName={classNames(cardClassName, card.checked ? "checked" : "")}
            {...card}
            showHandle={showHandle}
            disabled={disabled || card.disabled}
            dragHandleDisabled={disabled || card.dragHandleDisabled}
          />)}
        </div>
      </SortableContext>
    </DndContext>
  )

  function handleDragEnd(event: { active: any; over: any; }) {
    const { active, over } = event

    if (active.id !== over.id) {
      const oldIndex = cards.findIndex(card => card.id === active.id)
      const newIndex = cards.findIndex(card => card.id === over.id)

      setCards(arrayMove(cards, oldIndex, newIndex))
    }
  }
}

export default DraggableList
